module.exports = __webpack_public_path__ + "static/media/owllogo_black.356b3aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Cards/assets/owllogo_black.png
// module id = 5276
// module chunks = 11